<template>
  <div class="list-main"></div>
</template>

<template>
  <div class="list-main">
    <div
      class="search-wrapper-430 header-wrapper-430"
      style="margin-bottom: 8px"
    >
      <Form ref="searchForm" :model="formInline" :label-width="0" inline>
        <FormItem>
          <Input
            type="text"
            v-model="formInline.relId"
            placeholder="请输入优惠券编号"
            clearable
            class="search-input-430"
          >
          </Input>
        </FormItem>
        <FormItem>
          <Input
            type="text"
            v-model="formInline.couponName"
            placeholder="请输入优惠券名称"
            clearable
            class="search-input-430"
          >
          </Input>
        </FormItem>
        <FormItem>
          <ChooseSchool
            ref="chooseSchool"
            @on-change="onSchChange"
          ></ChooseSchool>
        </FormItem>
        <FormItem>
          <CascaderYearTerms
            ref="cascaderYearTerms"
            :placeholder="`请选择学期`"
            @on-change="onCascaderChange"
            @on-init="onCascaderInit"
          ></CascaderYearTerms>
        </FormItem>
        <FormItem>
          <Input
            type="text"
            v-model="formInline.studentName"
            placeholder="请输入学生姓名"
            clearable
            class="search-input-430"
          >
          </Input>
        </FormItem>

        <FormItem>
          <Select
            v-model="formInline.couponSts"
            placeholder="全部状态"
            clearable
            class="search-select-430"
          >
            <Option value="0">待使用</Option>
            <Option value="1">已使用</Option>
            <Option value="2">已过期</Option>
            <Option value="3">已失效</Option>
          </Select>
        </FormItem>

        <Button type="primary" @click="handleSubmit" style="margin-left: 16px"
          >查询</Button
        >
        <Button style="margin-left: 16px" @click="handleReset">重置</Button>
      </Form>
    </div>
    <div
      class="action-wrap flex justify-content_end"
      style="margin-bottom: 8px"
    >
      <Button
        class="btn-download"
        style="margin-left: 16px"
        type="primary"
        @click="handleDownload"
        >导出</Button
      >
    </div>
    <div class="table-main">
      <Table
        :columns="columns"
        :data="tableData"
        :loading="tableLoading"
        :max-height="pageTableHeight"
        border
      >
        <!-- <template slot="courseList" slot-scope="{ row, index }">
          <Poptip
            trigger="hover"
            word-wrap
            :width="getCourseAllDesc(row.courseList).length > 200 ? 600 : 300"
            :transfer="true"
            :content="getCourseAllDesc(row.courseList)"
          >
            <span class="click-btn-430">{{
              getCourseDesc(row.courseList)
            }}</span>
          </Poptip>
        </template> -->

        <template slot="courseList" slot-scope="{ row }">
          <div class="click-btn-430">
            <TablePoptip :content="getCourseDesc(row.courseList)">
            </TablePoptip>
          </div>
        </template>
        <template slot="couponName" slot-scope="{ row }">
          <TablePoptip :content="row.couponName"> </TablePoptip>
        </template>
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>

        <template slot="action" slot-scope="{ row, index }">
          <span
            class="click-btn-430"
            v-if="row.couponSts == 0"
            @click="disableUserCoupons(row)"
            >禁用</span
          >
          <span v-else class="click-btn-430">--</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-sizer
        show-total
        show-elevator
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="onPageSizeChange"
      ></Page>
    </div>
  </div>
</template>

<script>
import { columnsList } from '../assets/index.js';
import ChooseSchool from '@c/searchBlock/ChooseSchool';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import orderCenterApi from '@/request/orderCenter/index.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  components: {
    ChooseSchool,
    CascaderYearTerms
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      formInline: {
        couponName: '',
        relId: '',
        status: '',
        studentName: '',
        platType: 1,
        schoolId: '',
        yearCode: '',
        termCode: '',
        couponSts: ''
      },
      tableData: [],
      columns: columnsList,
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0

      },
      tableLoading: false

    };
  },
  computed: {
    pageTableHeight() {
      return this.windowHeight > 970 ? this.tableHeight - 180 : this.tableHeight - 90;
    }
  },
  activated() {
    this.handleSubmit();
  },
  mounted() {

  },
  methods: {
    getCourseDesc(list) {
      const str = list.map(item => { return item.classroomName; }).join('、');
      return str.length > 20 ? str.substring(0, 20) + '...' : str;
    },
    getCourseAllDesc(list) {
      const str = list.map(item => { return item.classroomName; }).join('、');
      return str;
    },
    getParameter() {
      this.formInline.yearCode = this.$refs.cascaderYearTerms.getResult()[0];
      this.formInline.termCode = this.$refs.cascaderYearTerms.getResult()[1];
      const { relId, couponName, yearCode, termCode, schoolId, platType, studentName, couponSts } = this.formInline;
      return {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        relId,
        couponName,
        yearCode,
        termCode,
        schoolId,
        studentName,
        platType,
        couponSts
      };
    },
    // 禁用
    async disableUserCoupons(row) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>禁用后此学员的券将无法再使用，若需要恢复请重新给学员发券，确定用将此券禁用吗?</p>',
        onOk: () => {
          orderCenterApi.disableUserCoupons({
            relId: row.relId
          }).then(res => {
            if (res.status == 200) {
              this.$Message.success('设置成功');
              this.getCouponsUsersList();
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 获取列表
    async getCouponsUsersList() {
      const parameter = this.getParameter();
      const reg = /^[0-9]{1,20}$/;
      if (parameter.couponId && !reg.exec(parameter.couponId)) {
        this.$Message.warning('请输入正确的优惠券编号');
        return null;
      }
      this.tableLoading = true;
      const res = await orderCenterApi.getCouponsUsersList(parameter);
      this.tableLoading = false;
      if (res.status == 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    handleSubmit() {
      this.pageInfo.pageNum = 1;
      this.getCouponsUsersList();
    },
    handleReset() {
      for (const k in this.formInline) {
        this.formInline[k] = '';
        if (['platType'].includes(k)) {
          this.formInline[k] = 1;
        }
      }
      this.$refs.chooseSchool.clear();
      this.$refs.cascaderYearTerms.handleDefault();
      this.handleSubmit();
    },

    async handleDownload() {
      const parameter = this.getParameter();
      delete parameter.pageNum;
      delete parameter.pageSize;

      this.$Spin.show();
      const res = await orderCenterApi.exportCouponsUsersDetail(parameter);
      console.log(res);
      this.$Spin.hide();
      downLoadByBlob(res);
    },
    onSchChange(info) {
      this.formInline.schoolId = info.schoolId != -1 ? info.schoolId : '';
    },
    onCascaderInit() {
      this.getCouponsUsersList();
    },
    onCascaderChange(v) {
      this.formInline.yearCode = v[0];
      this.formInline.termCode = v[1];
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getCouponsUsersList();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getCouponsUsersList();
    }

  }
};
</script>

<style lang="scss" scoped>
</style>
